var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 26.993 26.993"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".linkedin_svg__cls-1{fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin_svg__Group_23",
    "data-name": "Group 23",
    transform: "translate(-950 -2844.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin_svg__social-linkedin-outline",
    transform: "translate(945.5 2840.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "linkedin_svg__Path_14",
    d: "M12.853 27V14.97h-3.86V27Zm-1.786-13.852a2 2 0 0 0 2.088-2.074A1.99 1.99 0 0 0 11.088 9 2 2 0 0 0 9 11.074a1.985 1.985 0 0 0 2.039 2.074z",
    className: "linkedin_svg__cls-1",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "linkedin_svg__Path_15",
    d: "M22.542 14.695a3.92 3.92 0 0 0-3.488 1.955v-1.673h-3.867V27h3.867v-6.848a2.6 2.6 0 0 1 .134-.949 2.115 2.115 0 0 1 1.983-1.427c1.4 0 1.962 1.076 1.962 2.651V27H27v-7.024c0-3.607-1.912-5.28-4.458-5.28Z",
    className: "linkedin_svg__cls-1",
    "data-name": "Path 15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "linkedin_svg__Path_16",
    d: "M29.334 4.5H6.806A2.2 2.2 0 0 0 4.5 6.6v22.58a2.375 2.375 0 0 0 2.306 2.313h22.521a2.255 2.255 0 0 0 2.166-2.313V6.6a2.07 2.07 0 0 0-2.159-2.1m-.225 24.75H6.968a.214.214 0 0 1-.218-.218V6.891a.146.146 0 0 1 .141-.141H29.11a.15.15 0 0 1 .141.141V29.11a.15.15 0 0 1-.141.141Z",
    className: "linkedin_svg__cls-2",
    "data-name": "Path 16"
  })))));
};
export default SvgLinkedin;